export const DATE_LARGE = 'MMMM Do YYYY, h:mm:ss a'
export const DATE_MEDIUM = 'Do MMM YYYY, HH:mm'
export const DATE_SMALL = 'DD/MM/YYYY'
export const DATE_SMALL_v2 = 'DD/MM/YYYY HH:mm'



// WEBPACK FOOTER //
// ./src/constants/dates.js